import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button } from "antd";
import styles from "./TextWidget.module.css";
import Scrollbars from "react-custom-scrollbars-2";
import { CloseOutlined } from "@ant-design/icons";


const TextWidget = (props) => {
    const [isEditing, setIsEditing] = useState(false);
    const { textContent, setTextContent, removeWidget } = props;

    const widgetRef = useRef(null); // Ref for the widget container

    const toggleEditMode = (e) => {
        e.stopPropagation();
        setIsEditing(!isEditing);
    };

    const handleBlur = () => {
        setIsEditing(false);
    };

    // Close editing when clicking outside the widget
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (widgetRef.current && !widgetRef.current.contains(e.target)) {
                setIsEditing(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const quillModules = {
        toolbar: [
            [{ font: [] }],
            [{ size: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["link"],
            ["clean"],
        ],
    };

    const defaultHeight = props.widget.layout.h * 40 - 20;

    return (
        <div
            ref={widgetRef}
            className={`${styles.container}`}
            style={{
                height: defaultHeight,
            }}
        >
            <div
                className={styles.closeButtonContainer}
                onMouseDown={(e) => e.stopPropagation()}
            >
                <Button
                    style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => removeWidget(e)}
                    icon={<CloseOutlined style={{ color:"#121212", fontSize: 16 }} />}
                    type="link"
                    data-testid="closeWidget"
                />
            </div>

            <div style={{ padding: "10px" }}>
                {isEditing ? (
                    <div
                        style={{
                            height: defaultHeight - 60,
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        <ReactQuill
                            onMouseDown={(e) => e.stopPropagation()}
                            className={styles.editor}
                            value={textContent}
                            onChange={(value) => setTextContent(value)}
                            onBlur={handleBlur}
                            modules={quillModules}
                        />
                    </div>
                ) : (
                    <div>
                        <Scrollbars
                            style={{
                                height: defaultHeight ,
                            }}
                        >
                            <div className="ql-editor"
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={toggleEditMode}
                                dangerouslySetInnerHTML={{
                                    __html: textContent || "<i>Click here to edit</i>",
                                }}
                            ></div>
                        </Scrollbars>
                    </div>
                )}

                <div
                    className={`${styles.actionButton}`}
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <button
                        className={styles.saveButton}
                        onClick={toggleEditMode}
                    >
                        {isEditing ? "Save" : "Edit"}
                    </button>
                </div>
            </div>
        </div>
    );
};

const CloseButton = () => (
    <span style={{ fontSize: "16px", color: "#ff4d4f" }}>✖</span>
);

export default TextWidget;
